import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { generateHashCode } from '@src/quince-site-common/src/utils/stringUtil'
import { extractQueryParamFromPageLocation, getCookie, setCookie } from '@src/quince-site-integrated/src/utils'

import { setBucketForPageExperiment } from '../pageExperiment.state'
import { IPageLevelExperimentConfig } from '../pageExperiments.types'
import { isValidBucketValue, getBucketToAssign } from '../pageExperiments.utils'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'

export const pageExperimentInitialiser = (experiment: IPageLevelExperimentConfig) => {
  const { name, version, pageExpCookie, defaultBucket } = experiment

  // App might not receive query param, code not needed.
  const forcedPageAbBucket = extractQueryParamFromPageLocation(pageExpCookie)
  if (forcedPageAbBucket && isValidBucketValue(forcedPageAbBucket, experiment)) {
    setBucketForPageExperiment(name, forcedPageAbBucket)
    return
  }

  const pageExpCookieVal = getCookie(pageExpCookie)
  if (pageExpCookieVal) {
    const [cachedBucket, version] = pageExpCookieVal.split('_')
    if (cachedBucket && isValidBucketValue(cachedBucket, experiment) && experiment.version === version) {
      setBucketForPageExperiment(name, forcedPageAbBucket)
      return
    }
  }

  const userId = getCookie(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL) ?? getlbUserId() ?? ''
  const hashBucket = generateHashCode(name + '_' + version + '_' + userId) % 100
  const userBucket = getBucketToAssign(experiment, hashBucket)?.name ?? defaultBucket
  setBucketForPageExperiment(name, userBucket)
  setCookie(pageExpCookie, `${userBucket}_${version}_r1_auto`)
}
